// extracted by mini-css-extract-plugin
export default {"header-text":"styles_header-text__gVsPh","h1":"styles_h1__h02Zk","root":"styles_root__kSR0+","oldVersionLink":"styles_oldVersionLink__Rk3Ko"};